import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import Home from '@/views/Home.vue'
import store from '@/store'
import NewCompany from "@/views/NewCompany.vue"
import NewWorker from "@/views/NewWorker.vue"
import SignIn from "@/views/SignIn.vue"
import Profile from "@/views/Profile.vue";
import Dashboard from "@/views/Dashboard.vue";
import Announcement from "@/views/Announcement.vue";
import NewProfile from "@/views/NewProfile.vue";
import FAQ from "@/views/FAQ.vue";
import Contacts from "@/views/Contacts.vue";
import Help from "@/views/Help.vue";
import Privacy from "@/views/Privacy.vue";
import Partners from "@/views/Partners.vue";
import Worker from "@/views/Worker.vue";
import EditAnnouncement from "@/views/EditAnnouncement.vue";
import PublicAnnouncement from "@/views/PublicAnnouncement.vue";

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/faq',
        name: 'FAQ',
        component: FAQ
    },
    {
        path: '/contacts',
        name: 'Contacts',
        component: Contacts
    },
    {
        path: '/help',
        name: 'Help',
        component: Help
    },
    {
        path: '/privacy',
        name: 'Privacy',
        component: Privacy
    },
    {
        path: '/partners',
        name: 'Partners',
        component: Partners
    },
    {
        path: '/signIn',
        name: 'SignIn',
        component: SignIn,
        props: true
    },
    {
        path: '/new_profile',
        name: 'NewProfile',
        component: NewProfile,
    },
    {
        path: '/profile',
        name: 'Profile',
        component: Profile,
    },
    {
        path: '/newCompany',
        name: 'NewCompany',
        component: NewCompany
    },
    {
        path: '/newWorker',
        name: 'NewWorker',
        component: NewWorker
    },
    {
        path: '/announcement/:announcementUuid/edit',
        name: 'EditAnnouncement',
        component: EditAnnouncement,
        props: true
    },
    {
        path: '/announcement/:announcementUuid',
        name: 'Announcement',
        component: Announcement,
        props: true
    },
    {
        path: '/worker/:workerUuid',
        name: 'Worker',
        component: Worker,
        props: true
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard
    },
    {
        path: '/public_announcement/:companyUuid/:announcementUuid',
        name: 'PublicAnnouncement',
        component: PublicAnnouncement,
        props: true
    },
    {
        path: '/start', name: 'Start', redirect: to => {
            if (!store.getters['user'] || (!store.getters['isCompany'] && !store.getters['isWorker'])) {
                return '/new_profile'
            } else {
                return '/dashboard'
            }
        }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {

    if (['/newCompany', '/newWorker', '/profile', '/dashboard', '/announcement'].filter((path: string) => {
        return to.path.indexOf(path) > -1
    }).length > 0 && !store.getters['user']) {
        next({name: 'SignIn', params: {'redirectUrl': to.path}})
    } else if (['/newCompany', '/newWorker'].indexOf(to.path) > -1 && (store.getters['isCompany'] || store.getters['isWorker'])) {
        next({name: 'Dashboard'})
    } else next()
})

export default router
